import React, { useState, useEffect } from 'react';
import Input from '../../components/UI/Input/FormInput';
import CallToAction from '../../components/CallToAction/CallToAction';
import { checkValidity, sendVirtualPageView, isZipOutOfArea } from '../../shared/utility';
import axios from '../../axios-base';
import { cleanLocationProp } from '../../shared/utility';
import { Col, Row, Button, Form, FormGroup, UncontrolledAlert, Alert } from 'reactstrap';
import MediaUpload from '../MediaUpload/MediaUpload';
import CallToActionPlaceholder from '../../components/UI/Placeholder/CallToActionPlaceholder/CallToActionPlaceholder';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import SignUpServiceInfo from './SignUpServiceInfo';
import { IconInfoCircle } from '@tabler/icons-react';
import { usePhases } from '../../store/configStore';

function SignUp(props) {
    const votingPhases = usePhases();

    const [projectForm, setProjectForm] = useState({});
    const [mediaObjects, setMediaObjects] = useState([]);
    const [formIsValid, setFormIsValid] = useState(false);
    const [cta, setCta] = useState(null);

    let history = useHistory();

    const onUploadHandler = (responseArray) => {
        // The responseArray now contains objects with url and alt properties
        setMediaObjects(responseArray);
    };

    // TODO: Wie wirken sich die zahlreichen onChange-Events auf die Peformance aus? Ist es vlt. besser onSubmit zu nutzen?
    const onChangeHandler = (event, inputIdentifier) => {
        const updatedProjectForm = {
            ...projectForm,
        };

        // Deep clone
        const updatedFormElement = {
            ...updatedProjectForm[inputIdentifier],
        };

        /**
         *  Check if form element is of type file, and if so set selectedFile state AND value
         *  else only set value
         */
        if (updatedFormElement.elementType === 'file' && !updatedFormElement.elementConfig.multiple) {
            updatedFormElement.selectedFile = event.target.files[0];
            updatedFormElement.value = event.target.value;
        } else if (updatedFormElement.elementType === 'file' && updatedFormElement.elementConfig.multiple) {
            updatedFormElement.selectedFiles = event.target.files;
            updatedFormElement.value = event.target.value;
        } else if (updatedFormElement.elementType === 'checkbox') {
            updatedFormElement.value = event.target.checked;
        } else {
            updatedFormElement.value = event.target.value;
        }
        let validity = checkValidity(updatedFormElement.value, updatedFormElement.validation);
        updatedFormElement.valid = validity.isValid;
        updatedFormElement.errorMessage = validity.errorMessage ?? '';
        updatedFormElement.touched = true;
        updatedProjectForm[inputIdentifier] = updatedFormElement;

        let formIsValidValue = true;
        for (let inputIdentifier in updatedProjectForm) {
            // Allow submission even if zipcode is outside the Aktionsgebiet, but show a warning.
            if (inputIdentifier === 'contestantZipcode') {
                continue;
            }
            formIsValidValue = updatedProjectForm[inputIdentifier].valid && formIsValidValue;
        }
        setProjectForm(updatedProjectForm);
        setFormIsValid(formIsValidValue);
    };

    const onSubmitHandler = (event) => {
        event.preventDefault();
        // project-Objekt fuer axios POST bauen
        const fd = new FormData();
        const projectFormData = {};

        // Iterate through React state form and set values depending on elementType (i.e. 'file')
        for (let formElementIdentifier in projectForm) {
            if (
                projectForm[formElementIdentifier].elementType === 'file' &&
                !projectForm[formElementIdentifier].elementConfig.multiple
            ) {
                projectFormData[formElementIdentifier] = projectForm[formElementIdentifier].selectedFile;
                fd.append(formElementIdentifier, projectFormData[formElementIdentifier]);
            } else if (
                projectForm[formElementIdentifier].elementType === 'file' &&
                projectForm[formElementIdentifier].elementConfig.multiple
            ) {
                for (let [index, file] in Object.entries(projectForm[formElementIdentifier].selectedFiles)) {
                    fd.append(formElementIdentifier, projectForm[formElementIdentifier].selectedFiles[index]);
                    console.log(file);
                }
            } else {
                projectFormData[formElementIdentifier] = projectForm[formElementIdentifier].value;
                fd.append(formElementIdentifier, projectFormData[formElementIdentifier]);
            }
        }

        //Append image urls to the signup form
        fd.append('projectGallery', JSON.stringify(mediaObjects));

        axios
            .post('/projects', fd)
            .then((response) => {
                // Todo: Erfolgsnachricht anzeigen statt auf Startseite umzuleiten
                history.push('/vielen-dank');
            })
            .catch((error) => {
                console.log(error);
            });
    };

    useEffect(() => {
        axios
            .get('/cta/', {
                params: {
                    page: cleanLocationProp(props.location.pathname),
                },
            })
            .then((response) => {
                setCta(response.data[0]);
            })
            .catch((error) => {
                console.log(error);
            });

        axios
            .get('/options/')
            .then((response) => {
                setProjectForm(response.data[0].projectForm);
            })
            .catch((error) => {
                console.log(error);
            });

        sendVirtualPageView('Jetzt bewerben');
    }, [props.location.pathname]);

    const formElementsArray = [];

    for (let key in projectForm) {
        formElementsArray.push({
            id: key, // Left part of projectForm objects (i.e. projectTitle)
            config: projectForm[key], // Right part of projectForm objects (i.e. elementConfig{...})
        });
    }

    let button = null;

    if (formIsValid) {
        button = (
            <Button color="primary" className="anl_signup--send">
                Jetzt absenden
            </Button>
        );
    } else {
        button = (
            <Button color="primary" disabled>
                Bitte prüfen Sie Ihre Angaben
            </Button>
        );
    }

    let form = (
        <Form onSubmit={onSubmitHandler}>
            <UncontrolledAlert color="primary">
                <IconInfoCircle className="me-2 align-self-baseline" size={20} />
                Wenn nicht anders angegeben sind alle Felder Pflichtfelder
            </UncontrolledAlert>

            {mediaObjects.length > 0 && (
                <UncontrolledAlert color="primary" style={{ display: 'flex' }}>
                    <IconInfoCircle className="me-2 align-self-baseline" style={{ marginTop: '0.25em' }} size={20} />

                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <h4 className="alert-heading">Machen Sie Ihre Bilder für alle verständlich</h4>
                        <p>
                            <strong>Was ist hier zu tun?</strong>
                            <br />
                            Beschreiben Sie für jedes Bild kurz, was darauf zu sehen ist. Ihr Text wird blinden und
                            sehbehinderten Menschen automatisch vorgelesen, damit auch sie Ihr Projekt verstehen können.
                        </p>

                        <p>
                            <strong>Gutes Beispiel:</strong> "Die Jugendfeuerwehr bei einer Löschübung am See."
                        </p>

                        <p className="mb-0">
                            <strong>Wann können Sie das Feld leer lassen?</strong>
                            <br />
                            Nur dann, wenn ein Bild wirklich keine Information enthält (z. B. ein rein grafisches
                            Schmuckelement). Im Zweifel ist eine kurze Beschreibung immer{' '}
                            <strong>die richtige Entscheidung</strong>.
                        </p>
                    </div>
                </UncontrolledAlert>
            )}

            <FormGroup row>
                <Col sm={{ size: 12 }}>
                    <MediaUpload onUploadHandler={onUploadHandler} />
                </Col>
            </FormGroup>

            {(() => {
                const rows = [];
                let currentCols = [];
                let currentWidth = 0;
                let pendingZipBanner = null; // { text }

                const pushCurrentRow = (rowIndex) => {
                    if (currentCols.length === 0) return;
                    rows.push(<Row key={`form-row-${rowIndex}`}>{currentCols}</Row>);
                    if (pendingZipBanner) {
                        rows.push(
                            <Row key={`zip-banner-row-${rowIndex}`} className="d-none d-md-flex">
                                <Col xs="12" className="mb-3">
                                    <UncontrolledAlert color="warning" style={{ display: 'flex' }}>
                                        <IconInfoCircle
                                            className="me-2 align-self-baseline"
                                            style={{ marginTop: '0.25em' }}
                                            size={20}
                                        />
                                        <span>{pendingZipBanner.text}</span>
                                    </UncontrolledAlert>
                                </Col>
                            </Row>
                        );
                    }
                    currentCols = [];
                    currentWidth = 0;
                    pendingZipBanner = null;
                };

                let rowCounter = 0;

                formElementsArray.forEach((formElement, idx) => {
                    const inputEl = (
                        <Input
                            key={`${formElement.id}-input`}
                            name={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            {...(() => {
                                if (Object.hasOwn(formElement.config.validation, 'maxLength')) {
                                    return { maxLenght: formElement.config.validation.maxLength.value };
                                } else {
                                    return {};
                                }
                            })()}
                            value={formElement.config.value}
                            changed={(event) => onChangeHandler(event, formElement.id)}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            errorMessage={formElement.config.errorMessage}
                            validMessage={formElement.config.validMessage}
                            helperText={formElement.config.helperText}
                            helpDetails={formElement.config.helpDetails}
                            tooltip={formElement.config.tooltip}
                            invalid={!formElement.config.valid}
                        />
                    );

                    // Determine width from config (md columns); default to 12 if missing
                    const colWidth =
                        (formElement.config.elementConfig && formElement.config.elementConfig.columns) || 12;

                    // If adding this column would exceed 12, flush current row first
                    if (currentWidth > 0 && currentWidth + colWidth > 12) {
                        pushCurrentRow(rowCounter++);
                    }

                    currentCols.push(inputEl);
                    currentWidth += colWidth;

                    // If this is the ZIP field, decide if we should show the banner after this row
                    if (formElement.config.elementType === 'zipcode') {
                        const value = formElement.config.value || '';
                        const touched = !!formElement.config.touched;
                        const hasRealValidationError = !formElement.config.valid && touched;

                        const patterns =
                            (formElement.config.elementConfig && formElement.config.elementConfig.allowedCodes) || [];
                        const zipOutOfArea = touched && !hasRealValidationError && isZipOutOfArea(value, patterns);

                        if (zipOutOfArea) {
                            const warningText =
                                (formElement.config.elementConfig && formElement.config.elementConfig.zipCodeWarning) ||
                                'Hinweis: Diese Postleitzahl liegt außerhalb des Aktionsgebiets. Ihre Bewerbung kann trotzdem eingereicht werden; die Bearbeitung kann sich jedoch verzögern.';

                            currentCols.push(
                                <Col key={`zip-mobile-banner-${idx}`} xs="12" className="mb-3 d-block d-md-none">
                                    <UncontrolledAlert color="warning" style={{ display: 'flex' }}>
                                        <IconInfoCircle
                                            className="me-2 align-self-baseline"
                                            style={{ marginTop: '0.25em' }}
                                            size={20}
                                        />
                                        <span>{warningText}</span>
                                    </UncontrolledAlert>
                                </Col>
                            );

                            pendingZipBanner = { text: warningText };
                        }
                    }

                    if (currentWidth === 12) {
                        pushCurrentRow(rowCounter++);
                    }
                });

                if (currentCols.length > 0) {
                    pushCurrentRow(rowCounter++);
                }

                return rows;
            })()}

            <a className="visually-hidden-focusable" href="#form-entry-mark">
                Zum Anfang des Formulars springen
            </a>
            <a className="visually-hidden-focusable" href="#signup-service-info">
                Haben Sie Probleme oder Fragen beim bewerben? Wir stehen Ihnen gerne zur Seite! Hier klicken, um zu den
                Informationen zum Bewerbungsservice zu springen.
            </a>

            <FormGroup row>
                <Col sm={{ size: 12 }}>{button}</Col>
            </FormGroup>
        </Form>
    );

    let ctaRender = <CallToActionPlaceholder />;

    if (cta) {
        ctaRender = (
            <CallToAction
                btnClass={`anl_cta--${cta.page}--btn-${cta.position}`}
                headline={cta.headline}
                copy={cta.copy}
                buttonText={cta.buttonText}
                buttonColor={cta.buttonColor}
                linkUrl={cta.linkUrl}
                outline={cta.outline}
                buttonVisibility={cta.buttonVisibility}
            />
        );
    }

    const signUpFinished = votingPhases && !votingPhases.signUpActive && votingPhases.campaignLaunched;

    if (signUpFinished) {
        return (
            <>
                <Helmet>
                    <title>{`Bewerbung beendet | ${process.env.REACT_APP_PROJECT_TITLE}`}</title>
                </Helmet>
                <Row className="my-5">
                    <Col className="text-center">
                        <Alert color="info">
                            <h2>Die Bewerbungsphase ist leider beendet.</h2>
                            <p>Sie können sich für diesen Wettbewerb nicht mehr bewerben.</p>
                            <Button color="primary" onClick={() => history.push('/')}>
                                Zur Startseite
                            </Button>
                        </Alert>
                    </Col>
                </Row>
            </>
        );
    }

    return (
        <>
            <Helmet>
                <title>{`Jetzt bewerben | ${process.env.REACT_APP_PROJECT_TITLE}`}</title>
            </Helmet>
            <Row className="mb-3">
                <a className="visually-hidden-focusable" href="#signup-service-info">
                    Zu den Informationen bezüglich des Bewerbungsservices springen
                </a>
                <a className="visually-hidden-focusable" href="#form-entry-mark">
                    Direkt zum Formular springen
                </a>
                <Col xs="12" md="7" className="py-3">
                    {ctaRender}
                </Col>
                <Col id="signup-service-info" xs="12" md="5" className="p-3">
                    <SignUpServiceInfo />
                </Col>
            </Row>
            <Row>
                <Col id="form-entry-mark">{form}</Col>
            </Row>
        </>
    );
}

export default SignUp;
